import { LinkedTaskFlowState, LinkedTaskItemStateType } from '../state/LinkedTaskStateTypes';

export function LinkedTaskFlowInitialState(flowId?: string, flowName?: string): LinkedTaskFlowState {
  return {
    flowId,
    flowName,
    selectedOutputs: [],
    dqw: {
      enableTrigger: true,
      isSevere: false,
      message: '',
    },
    stopRemainingTasks: true,
    dqwEnabled: false,
  };
}

// Helper function to update a value at a specific position in an array
export function updateInArray<T>(position: number, value: T, array: T[]): T[] {
  return [
    ...array.slice(0, position),
    value,
    ...array.slice(position + 1)
  ];
}

export function isLinkedTaskFlowState(state: LinkedTaskItemStateType): state is LinkedTaskFlowState {
  return (state as any).flowId !== undefined;
}
